
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDiver as ObiDiverElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-diver.js';
 
 
 

 
 export const ObiDiver = createComponent({
   react: React,
   tagName: 'obi-diver',
   elementClass: ObiDiverElement,
   events: {
     
   }
  });
 
 